import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import s from './MapNav.scss';

class MenuIcon extends React.Component {

  render() {
    return (
      <li className={this.props.liClass}>
        <OverlayTrigger trigger={['hover', 'focus']} placement={this.props.textPlacement} overlay={this.props.overlay}>
          <a href="#" onClick={this.props.actionOnClick}>
            {
              this.props.src ?
                <div className="images">
                  <img className={`first-img-style ${this.props.iconStyling}`} src={this.props.src} role="presentation" />
                  <img className={`second-img-style ${this.props.iconStyling}`} src={this.props.src} role="presentation" />
                  <img className={`third-img-style ${this.props.iconStyling}`} src={this.props.src} role="presentation" />
                  <img className={`fourth-img-style ${this.props.iconStyling}`} src={this.props.src} role="presentation" />
                </div>
                 :
                <i className={`icon-style ${this.props.iconStyling}`} />
            }
          </a>
        </OverlayTrigger>
      </li>
    );
  }
}

export default withStyles(s)(MenuIcon);




// WEBPACK FOOTER //
// src/components/MapNav/MenuIcon.js